import { render, staticRenderFns } from "./idCard.vue?vue&type=template&id=3b697d16&"
import script from "./idCard.vue?vue&type=script&lang=js&"
export * from "./idCard.vue?vue&type=script&lang=js&"
import style0 from "./idCard.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports